export interface StewardDef {
  id: string;
  name: { en: string; pt: string };
  flavor: { en: string; pt: string };
  /** Which encounter this steward operates */
  encounterId: string;
  /** Seconds between each automated click at level 1 (level N = N clicks per cycle) */
  cycleSec: number;
  /** Cost in coin for first hire */
  baseCost: number;
  /** Cost multiplier per additional level */
  costMul: number;
  /** Required Φ before they appear */
  unlockPhi: number;
}

export const STEWARDS: StewardDef[] = [
  {
    id: 'torchbearer',
    name: { en: 'Torchbearer', pt: 'Tochador' },
    flavor: {
      en: 'Walks the forest path so you no longer have to.',
      pt: 'Percorre a trilha da floresta para que você não precise.',
    },
    encounterId: 'forestWalk',
    cycleSec: 2.5,
    baseCost: 60,
    costMul: 1.55,
    unlockPhi: 30,
  },
  {
    id: 'pickhand',
    name: { en: 'Pickhand', pt: 'Mineiro' },
    flavor: {
      en: 'Knows which beams to trust. Mostly.',
      pt: 'Sabe em quais vigas confiar. Quase sempre.',
    },
    encounterId: 'oldMine',
    cycleSec: 4,
    baseCost: 200,
    costMul: 1.6,
    unlockPhi: 60,
  },
  {
    id: 'watchhand',
    name: { en: 'Watchhand', pt: 'Vigia' },
    flavor: {
      en: 'Returns from the tower with coin in pocket. Does not explain.',
      pt: 'Volta da torre com moeda no bolso. Não explica.',
    },
    encounterId: 'ruinedTower',
    cycleSec: 5,
    baseCost: 550,
    costMul: 1.6,
    unlockPhi: 120,
  },
  {
    id: 'marshhand',
    name: { en: 'Marshhand', pt: 'Pantaneiro' },
    flavor: {
      en: 'Hums between footsteps. The bog hums back.',
      pt: 'Cantarola entre os passos. O pântano cantarola de volta.',
    },
    encounterId: 'sourBog',
    cycleSec: 7.5,
    baseCost: 1500,
    costMul: 1.65,
    unlockPhi: 220,
  },
  {
    id: 'ranger',
    name: { en: 'Border Ranger', pt: 'Patrulheira da Fronteira' },
    flavor: {
      en: 'Takes the camp before the bandits return. Always before.',
      pt: 'Toma o acampamento antes dos bandidos voltarem. Sempre antes.',
    },
    encounterId: 'banditCamp',
    cycleSec: 10,
    baseCost: 4000,
    costMul: 1.7,
    unlockPhi: 450,
  },
];

export function stewardById(id: string): StewardDef | undefined {
  return STEWARDS.find((s) => s.id === id);
}

export function stewardCost(def: StewardDef, currentLevel: number): number {
  return Math.ceil(def.baseCost * Math.pow(def.costMul, currentLevel));
}
